import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Start24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.276 7.42982C10.9098 7.37732 10.5361 7.43068 10.1992 7.5836C9.86224 7.73653 9.57607 7.98264 9.37445 8.2929C9.17283 8.60317 9.06414 8.96463 9.06124 9.33463V14.6504C9.0596 15.0226 9.1655 15.3874 9.36624 15.7009C9.5674 16.0151 9.8552 16.2643 10.1949 16.4184C10.5346 16.5726 10.9116 16.6252 11.2805 16.5697C11.6486 16.5145 11.9928 16.3541 12.2719 16.1078L12.2738 16.1062L15.7088 13.1042L15.7113 13.102C15.8676 12.9641 15.9929 12.7945 16.0786 12.6045C16.1644 12.4145 16.2088 12.2084 16.2088 12C16.2088 11.7915 16.1644 11.5854 16.0786 11.3954C15.9929 11.2054 15.8676 11.0358 15.7113 10.8979L12.2711 7.88406L12.2663 7.87994C11.9859 7.63851 11.6423 7.48233 11.276 7.42982ZM11.0675 8.88434C10.9787 8.87161 10.8881 8.88455 10.8065 8.92162C10.7248 8.9587 10.6554 9.01836 10.6065 9.09357C10.5581 9.16817 10.5317 9.25498 10.5306 9.34391V14.6563C10.5301 14.7457 10.5555 14.8333 10.6037 14.9085C10.6519 14.9838 10.7208 15.0435 10.8022 15.0804C10.8835 15.1173 10.9739 15.1299 11.0622 15.1167C11.1506 15.1034 11.2332 15.0648 11.3002 15.0056L11.3035 15.0027L14.3091 12.376C14.5369 12.1769 14.5371 11.8228 14.3096 11.6234L11.3058 8.99189C11.2381 8.93426 11.1555 8.89696 11.0675 8.88434Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.46939 12C4.46939 7.84096 7.84096 4.46939 12 4.46939C16.159 4.46939 19.5306 7.84096 19.5306 12C19.5306 16.159 16.159 19.5306 12 19.5306C7.84096 19.5306 4.46939 16.159 4.46939 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
